
import { JournalKeys } from '@/i18n/types';

export const journal: Record<JournalKeys, string> = {
  journal: 'Journal',
  addEntry: 'Add Entry',
  editEntry: 'Edit Entry',
  deleteEntry: 'Delete Entry',
  entryTitle: 'Entry Title',
  content: 'Content',
  moodRating: 'Mood Rating',
  tags: 'Tags',
  viewDetails: 'View Details',
  createdAt: 'Created At',
  writeJournalEntry: 'Write Journal Entry',
  journalEntryPlaceholder: 'How was your day?',
  dailyHighlight: 'Daily Highlight (Optional)',
  saveEntry: 'Save Entry',
  journalEntries: 'Entries',
  noJournalEntries: 'No journal entries yet. Start writing!',
  personalJournal: 'Personal Journal',
  journalDesc: 'Record your thoughts, experiences and reflections',
  editJournalEntry: 'Edit Journal Entry',
  deleteJournalEntry: 'Delete Journal Entry',
  deleteJournalEntryConfirm: 'Are you sure you want to delete this journal entry? This action cannot be undone.',
  exportJournal: 'Export to PDF',
  exportedOn: 'Exported on',
  date: 'Date',
  highlight: 'Highlight',
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  viewEntriesByDate: 'View entries by date',
  entriesFor: 'Entries for',
  noEntriesForDate: 'No entries for this date',
  search: 'Search',
  statistics: 'Statistics',
  searchPlaceholder: 'Search in your entries...',
  totalEntries: 'Total Entries',
  thisMonth: 'This Month',
  weeklyAverage: 'Weekly Average'
};
